import { PurchasedItemType } from './@types';


export const OmsItemTransformer = (data: PurchasedItemType[]) => data.map((item) => ({
  itemId: item.itemSku,
  name: item.itemName,
  packSize: item.productSize,
  totalPrice: item.unitPrice,
  actualPrice: item.itemMrp,
  imageUrl: item.imageUrl,
  quantity: item.itemQuantity,
  variantColorName: item.variantColorName,
  variantColorUrl: item.variantColorUrl,
  shadeImage: item.shadeImage,
  shadeName: item.shadeName,
  isMto: item.is_mto,
  l3CategoryName: item?.primaryCategories?.l3?.name,
  l2CategoryName: item?.primaryCategories?.l2?.name,
  l1CategoryName: item?.primaryCategories?.l1?.name,
  productUrl: item.productUrl,
  productId: item.productId,
  productType: item.type,
  offerCommunication: item?.offerCommunication,
  parentId: item.parentId,
  preShippedEstimatedDeliveryMessage: item.additionalAttributes?.preShippedEstimatedDeliveryMessage, // field contains delivery date details need to be shown on order confirmation page
  showPreShippedEdd : item.showPreShippedEdd, // showPreShippedEdd describes whether EDD should be shown or not
  brandNames: item.brandNames, // required for facebook pixel
  estimatedDeliveryHrs: item.additionalAttributes?.expectedDeliveryHrs || 0,
  estimatedDeliveryTime: item.additionalAttributes?.estimatedDeliveryTime || '',
  discount: item?.discount,
  freeSample: item?.freeSample,
  freeItem: item?.freeItem
}));

